import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { useState } from 'react';
import usePreviewEventFormStyles from './usePreviewEventFormStyles';
import NavigationMenu from './components/NavigationMenu';
import ContentSection from './components/ContentSection';
const PreviewEventForm = (props) => {
    const styles = usePreviewEventFormStyles();
    const [activeLayout, setActiveLayout] = useState('desktop');
    return (_jsxs(Box, { className: 'preview-event-form-container', sx: styles.mainContainer, children: [_jsx(NavigationMenu, { activeLayout: activeLayout, setActiveLayout: setActiveLayout }), _jsx(Box, { className: 'content-container', sx: styles.contentContainer, children: _jsx(ContentSection, { selectedLayout: activeLayout }) })] }));
};
export default PreviewEventForm;
